module.exports = __webpack_public_path__ + "img/liang_highlight.c3944b2b.png";